export const SET_UNIT_OF_MEASURE_COLLECTION = 'UNIT_OF_MEASURE/SET_UNIT_OF_MEASURE_COLLECTION';
